import 'isomorphic-fetch';
import { mergeWith } from 'lodash-es';
import isAbsoluteUrl from 'ha/utils/isAbsoluteUrl';

export default class FetchClient {
  private baseUrl: string;

  private options: RequestInit;

  constructor(url: string, options?: RequestInit) {
    this.baseUrl = url;
    this.options = { credentials: 'include', ...options };
  }

  fetch(url: string, options?: RequestInit) {
    return fetch(
      isAbsoluteUrl(url) ? url : `${this.baseUrl}${url}`,
      mergeWith({}, this.options, options || {}, (baseOption, newOption) =>
        Array.isArray(baseOption) && Array.isArray(newOption)
          ? newOption
          : undefined,
      ),
    );
  }
}
